/*
  Boot care product page (sections/aa-product-*.liquid).
  - The boots' material picks the set's version: html[data-aa-mat] = smooth | soft.
    CSS shows the matching copy; this file keeps every material select, the buy box's
    variant and the photos in step.
  - Buy box: the set or the single. Available: add to cart through Dawn's product-form.
    Coming soon: "Email me when it's in" signs up for Klaviyo's back-in-stock email.
  - Gallery thumbnails and zoom in place; the guarantee popup; the routine's pins;
    the how-to tabs; the phone buy bar.
*/
(function () {
  if (window.aaProductPage) return;
  window.aaProductPage = true;

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wide = window.matchMedia('(min-width: 990px)');
  var phone = window.matchMedia('(max-width: 749px)');

  // button labels are Title Case (Ed, 2026-10-16): "the set" -> "the Set"
  var SMALL = /^(a|an|the|and|but|or|for|nor|as|at|by|in|of|off|on|per|to|up|via)$/i;
  function titleCase(text) {
    var words = String(text || '').split(' ');
    return words
      .map(function (w, i) {
        if (i > 0 && SMALL.test(w)) return w.toLowerCase();
        return w.charAt(0).toUpperCase() + w.slice(1);
      })
      .join(' ');
  }

  function all(sel, el) {
    return Array.prototype.slice.call((el || document).querySelectorAll(sel));
  }
  function shown(el) {
    return !!el && el.getClientRects().length > 0;
  }
  function mat() {
    return root.dataset.aaMat === 'smooth' ? 'smooth' : 'soft';
  }

  /* ---------- material ---------- */
  function setMat(m) {
    root.dataset.aaMat = m;
    all('[data-aa-dd]').forEach(function (d) {
      var label = '';
      all('[role=option]', d).forEach(function (o) {
        var on = o.dataset.value === m;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) label = o.querySelector('span').textContent;
      });
      d.querySelector('[data-aa-dd-value]').textContent = label;
    });
    all('[data-aa-label]').forEach(function (l) {
      updateBuy(l);
      showSlide(l, currentSlide(l));
    });
    all('[data-aa-howto]').forEach(syncTabs);
    all('[data-aa-routine]').forEach(function (r) {
      light(r, +r.dataset.aaHome || 0);
      fitPhoto(r);
    });
  }

  /* ---------- buy box ---------- */
  function chosen(l) {
    var radio = l.querySelector('input[type=radio][name^="aa-choice"]:checked');
    var kind = radio ? radio.value : 'set';
    if (kind === 'single') return l.querySelector('[data-aa-choice="single"]');
    var vers = all('[data-aa-choice="set"]', l);
    for (var i = 0; i < vers.length; i++) {
      if (vers[i].dataset.aaMatChoice === mat() || vers.length === 1) return vers[i];
    }
    return vers[0];
  }

  function updateBuy(l) {
    var c = chosen(l);
    if (!c) return;
    var isSet = c.dataset.aaChoice === 'set';
    var available = c.dataset.aaAvailable === 'true';
    var coming = c.dataset.aaComing === 'true';
    var id = l.querySelector('[data-aa-id]');
    if (id) id.value = c.dataset.aaVariant;

    var cart = l.querySelector('[data-aa-cart]');
    var notifyOpen = l.querySelector('[data-aa-notify-open]');
    var notify = l.querySelector('[data-aa-notify]');
    var done = l.querySelector('[data-aa-done]');
    var soldout = l.querySelector('[data-aa-soldout]');
    var stock = l.querySelector('[data-aa-stock]');
    var setfor = l.querySelector('[data-aa-setfor]');
    var label = l.querySelector('[data-aa-cart-label]');

    if (setfor) setfor.hidden = !isSet;
    if (label) label.textContent = titleCase('Add ' + c.dataset.aaWhat + ' to Cart');

    var signedUp = done && done.dataset.aaFor === c.dataset.aaVariant;
    cart.hidden = !available;
    soldout.hidden = available || coming;
    if (stock) stock.hidden = !coming;
    if (!coming) {
      notifyOpen.hidden = true;
      notify.hidden = true;
      done.hidden = true;
    } else if (signedUp) {
      notifyOpen.hidden = true;
      notify.hidden = true;
      done.hidden = false;
    } else {
      done.hidden = true;
      var open = l.dataset.aaNotifyState === 'true';
      notifyOpen.hidden = open;
      notify.hidden = !open;
    }
    updateBar(l, c, available, coming);
  }

  /* ---------- back in stock (Klaviyo) ---------- */
  function subscribe(l, form) {
    /* a notify form can name its own variant (sock page); otherwise it follows the buy box */
    var c = form.dataset.aaVariant ? form.dataset : chosen(l);
    var own = !!form.dataset.aaVariant;
    var input = form.querySelector('input[type=email]');
    var err = form.querySelector('[data-aa-notify-error]');
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      err.textContent = 'Enter an email address, like you@example.com.';
      err.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', err.id);
      input.focus();
      return;
    }
    err.hidden = true;
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedby');
    var btn = form.querySelector('button[type=submit]');
    btn.disabled = true;
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(l.dataset.aaCompany), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + (c.aaVariant || c.dataset.aaVariant) } },
          },
        },
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        var done = l.querySelector('[data-aa-done]');
        done.textContent = "Thanks. We'll email you when " + (c.aaWhat || c.dataset.aaWhat) + ' is in.';
        done.dataset.aaFor = c.aaVariant || c.dataset.aaVariant;
        l.dataset.aaNotifyState = 'false';
        if (own) {
          form.hidden = true;
          done.hidden = false;
        } else updateBuy(l);
        done.setAttribute('tabindex', '-1');
        done.focus();
      })
      .catch(function () {
        err.textContent = "That didn't go through. Try again, or email info@adventureandy.com.";
        err.hidden = false;
      })
      .finally(function () {
        btn.disabled = false;
      });
  }

  /* ---------- gallery ---------- */
  function slides(l) {
    return all('[data-aa-slide]', l).filter(function (s) {
      var m = s.dataset.aaShow;
      return !m || m === mat();
    });
  }
  function currentSlide(l) {
    var s = slides(l);
    var i = +(l.dataset.aaPic || 0);
    return i < s.length ? i : 0;
  }
  /* every width (phones Ed, 2026-10-17; desktop Ed, 2026-10-23: "all hero images scrollable in
     the same way"): every photo sits in one row that snaps a photo at a time; the thumbnails follow.
     On desktop a mouse drags the row (snapping to the nearest photo on release) and small arrows
     step a photo at a time. */
  function swiping(l) {
    var main = l.querySelector('.aa-main');
    var on = !!main;
    if (main) main.classList.toggle('aa-swipe', on);
    if (on && !main.dataset.aaSwipe) {
      main.dataset.aaSwipe = 'true';
      var rest = 0;
      var settle = function () {
        if (!main.classList.contains('aa-swipe') || !main.clientWidth) return;
        var n = Math.round(main.scrollLeft / main.clientWidth);
        var s = slides(l);
        if (n >= s.length) n = s.length - 1;
        if (n < 0 || +l.dataset.aaPic === n) return;
        l.dataset.aaPic = n;
        all('[data-aa-thumb]', l).forEach(function (b) {
          b.setAttribute('aria-pressed', +b.dataset.aaThumb === n ? 'true' : 'false');
        });
        var th = l.querySelector('[data-aa-thumbs]');
        if (th) keepThumb(th, n);
      };
      main.addEventListener('scroll', function () {
        clearTimeout(rest);
        rest = setTimeout(settle, 90);
      }, { passive: true });
      main.addEventListener('scrollend', settle);
      main.addEventListener('scroll', function () { galArrows(l); }, { passive: true });
      dragScroll(main, 'aa-swipe', true);
      var gal = main.closest('.aa-gal');
      if (gal && !gal.querySelector('[data-aa-gal-prev]')) {
        [['prev', 'Previous photo', 'M15 6l-6 6 6 6'], ['next', 'Next photo', 'M9 6l6 6-6 6']].forEach(function (d) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'aa-gal-arrow aa-gal-arrow--' + d[0];
          b.setAttribute('data-aa-gal-' + d[0], '');
          b.setAttribute('aria-label', d[1]);
          b.hidden = true;
          b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="' + d[2] + '"/></svg>';
          b.addEventListener('click', function () {
            var n = currentSlide(l) + (d[0] === 'next' ? 1 : -1);
            if (n >= 0 && n < slides(l).length) showSlide(l, n, true);
          });
          gal.appendChild(b);
        });
      }
    }
    galArrows(l);
    return on ? main : null;
  }
  // the photo arrows: shown only where there is a photo to go to
  function galArrows(l) {
    var prev = l.querySelector('[data-aa-gal-prev]');
    var next = l.querySelector('[data-aa-gal-next]');
    if (!prev || !next) return;
    var main = l.querySelector('.aa-main');
    var n = slides(l).length;
    var at = main && main.clientWidth ? Math.round(main.scrollLeft / main.clientWidth) : currentSlide(l);
    prev.hidden = n < 2 || at <= 0;
    next.hidden = n < 2 || at >= n - 1;
  }
  function showSlide(l, i, glide) {
    var s = slides(l);
    if (!s.length) return;
    if (l.dataset.aaZoomed) zoom(l, false);
    if (i >= s.length) i = 0;
    l.dataset.aaPic = i;
    var strip = swiping(l);
    all('[data-aa-slide]', l).forEach(function (x) {
      x.hidden = strip ? false : x !== s[i];
    });
    if (strip) {
      strip.scrollTo({ left: s[i].offsetLeft, behavior: glide && !reduce.matches ? 'smooth' : 'auto' });
    }
    var thumbs = l.querySelector('[data-aa-thumbs]');
    if (s.length < 2) {
      thumbs.innerHTML = '';
      return;
    }
    thumbs.innerHTML = '';
    s.forEach(function (x, n) {
      var img = x.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'aa-thumb';
      b.dataset.aaThumb = n;
      b.setAttribute('aria-pressed', n === i ? 'true' : 'false');
      b.setAttribute('aria-label', 'Show ' + (img ? img.alt : 'photo ' + (n + 1)));
      if (img) {
        var t = document.createElement('img');
        t.src = x.dataset.aaThumbSrc || img.currentSrc || img.src;
        t.alt = '';
        t.loading = 'lazy';
        b.appendChild(t);
      }
      thumbs.appendChild(b);
    });
    // the thumbnails run in one row along the foot of the photo and swipe sideways, on every boot
    // care page (Ed, 2026-10-23: first the set's long gallery, then "all of them"); the sock page
    // keeps its own layout
    var gal = thumbs.closest('.aa-gal');
    var many = s.length > 1 && gal && !gal.closest('.aa-pp-label--sock');
    thumbs.classList.toggle('aa-thumbs--row', !!many);
    if (many && !thumbs.dataset.aaDrag) {
      thumbs.dataset.aaDrag = '1';
      dragScroll(thumbs);
    }
    if (gal) gal.classList.toggle('aa-gal--row', !!many);
    if (many) keepThumb(thumbs, i);
  }
  // a mouse can drag the thumbnail row sideways (Ed, 2026-10-23); a real drag (6px or more)
  // doesn't count as a click on the thumbnail under it
  // snap: the main photo row settles on the nearest photo when let go
  function dragScroll(row, rowClass, snap) {
    var drag = null;
    rowClass = rowClass || 'aa-thumbs--row';
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !row.classList.contains(rowClass)) return;
      if (row.classList.contains('is-zoomed')) return;
      drag = { x: e.clientX, left: row.scrollLeft, moved: false, id: e.pointerId };
    });
    row.addEventListener('pointermove', function (e) {
      if (!drag) return;
      // the button came up somewhere we didn't hear it: stop dragging
      if (!(e.buttons & 1)) {
        end();
        return;
      }
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        row.setPointerCapture(drag.id);
        row.classList.add('aa-dragging');
      }
      row.scrollLeft = drag.left - dx;
    });
    function end() {
      if (!drag) return;
      var moved = drag.moved;
      drag = null;
      row.classList.remove('aa-dragging');
      if (moved) {
        row.dataset.aaDragged = '1';
        setTimeout(function () { delete row.dataset.aaDragged; }, 0);
        if (snap && row.clientWidth) {
          row.scrollTo({ left: Math.round(row.scrollLeft / row.clientWidth) * row.clientWidth, behavior: reduce.matches ? 'auto' : 'smooth' });
        }
      }
    }
    row.addEventListener('pointerup', end);
    row.addEventListener('pointercancel', end);
    row.addEventListener('lostpointercapture', end);
    window.addEventListener('pointerup', end);
    window.addEventListener('blur', end);
    row.addEventListener('click', function (e) {
      if (!row.dataset.aaDragged) return;
      e.stopPropagation();
      e.preventDefault();
    }, true);
  }
  // keeps the picked thumbnail in view in the row (moves the row only, never the page)
  function keepThumb(thumbs, i) {
    var b = thumbs.children[i];
    if (!b || !thumbs.classList.contains('aa-thumbs--row')) return;
    var left = b.offsetLeft - thumbs.offsetLeft;
    if (left < thumbs.scrollLeft) thumbs.scrollLeft = left - 4;
    else if (left + b.offsetWidth > thumbs.scrollLeft + thumbs.clientWidth) thumbs.scrollLeft = left + b.offsetWidth - thumbs.clientWidth + 4;
  }
  /* ---------- zoom: the photo magnifies inside its own panel (Ed, 2026-10-21: no full-screen
     window). The zoomed area follows the mouse, or a finger on phones; a second click, Escape or
     another photo zooms back out. ---------- */
  var ZOOM = 2.5;
  function zoomAt(l, e) {
    var s = slides(l)[currentSlide(l)];
    var img = s && s.querySelector('img');
    if (!img || !l.dataset.aaZoomed || !img.offsetWidth) return;
    var r = s.getBoundingClientRect();
    var x = ((e.clientX - r.left - img.offsetLeft) / img.offsetWidth) * 100;
    var y = ((e.clientY - r.top - img.offsetTop) / img.offsetHeight) * 100;
    img.style.transformOrigin =
      Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
  }
  function zoom(l, on, e) {
    var main = l.querySelector('.aa-main');
    var btn = l.querySelector('[data-aa-zoom-open]');
    all('[data-aa-slide] img', l).forEach(function (im) {
      if ('aaSrcset' in im.dataset) {
        if (im.dataset.aaSrcset) im.srcset = im.dataset.aaSrcset;
        else im.removeAttribute('srcset');
        delete im.dataset.aaSrcset;
      }
      im.style.transform = '';
      im.style.transformOrigin = '';
    });
    var s = on && slides(l)[currentSlide(l)];
    var img = s && s.querySelector('img');
    if (img) {
      // the sharp copy, so the zoomed photo isn't blurry
      if (s.dataset.aaZoom) {
        img.dataset.aaSrcset = img.getAttribute('srcset') || '';
        img.srcset = s.dataset.aaZoom + ' 2000w';
      }
      l.dataset.aaZoomed = 'true';
      img.style.transformOrigin = '50% 50%';
      if (e && e.clientX) zoomAt(l, e);
      img.style.transform = 'scale(' + ZOOM + ')';
    } else {
      delete l.dataset.aaZoomed;
    }
    if (main) main.classList.toggle('is-zoomed', !!img);
    if (btn) {
      btn.setAttribute('aria-pressed', img ? 'true' : 'false');
      btn.setAttribute('aria-label', img ? 'Zoom out' : 'Zoom in on the photo');
    }
  }
  // a finger or mouse that pans the zoomed photo mustn't also zoom it out on release
  var panFrom = null;
  document.addEventListener('pointerdown', function (e) {
    var main = e.target.closest && e.target.closest('.aa-main.is-zoomed');
    panFrom = main ? { x: e.clientX, y: e.clientY, moved: false } : null;
  });
  document.addEventListener('pointermove', function (e) {
    var main = e.target.closest && e.target.closest('.aa-main.is-zoomed');
    if (!main) return;
    if (e.pointerType === 'touch' && !panFrom) return;
    if (panFrom && Math.abs(e.clientX - panFrom.x) + Math.abs(e.clientY - panFrom.y) > 8) panFrom.moved = true;
    zoomAt(main.closest('[data-aa-label]'), e);
  });

  /* ---------- phone buy bar ---------- */
  function updateBar(l, c, available, coming) {
    var price = l.querySelector('[data-aa-sbar-price]');
    var btn = l.querySelector('[data-aa-sbar-btn]');
    if (!price || !btn) return;
    price.textContent = c.dataset.aaPrice;
    btn.textContent = available ? 'Add to Cart' : coming ? 'Email Me' : 'Sold Out';
  }

  /* ---------- routine ---------- */
  function light(r, n, pinKey) {
    all('[data-aa-step]', r).forEach(function (el) {
      var isPin = el.classList.contains('aa-pin');
      var on = isPin && pinKey ? el.dataset.aaPin === pinKey : +el.dataset.aaStep === n;
      el.classList.toggle('is-on', on);
      if (isPin) el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  /* beside the steps, the photo fits inside their height; stacked on phones it runs full width */
  function fitPhoto(r) {
    var ph = r.querySelector('.aa-rt-photo');
    var fr = all('[data-aa-frame]', r).filter(shown)[0];
    if (!ph || !fr) return;
    all('[data-aa-frame]', r).forEach(function (f) {
      f.style.width = '';
      f.style.height = '';
    });
    if (!wide.matches) return;
    var img = fr.querySelector('img');
    var go = function () {
      var head = r.querySelector('.aa-rt-head');
      var body = r.querySelector('.aa-rt-body');
      var cs = getComputedStyle(ph);
      var h = head.offsetHeight + body.offsetHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
      var w = ph.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var ratio = img.naturalWidth / img.naturalHeight;
      var fh = Math.min(h, w / ratio);
      fr.style.height = fh + 'px';
      fr.style.width = fh * ratio + 'px';
    };
    if (img.complete && img.naturalWidth) go();
    else img.addEventListener('load', go, { once: true });
  }

  /* ---------- how to ---------- */
  function selectTab(h, key) {
    all('[data-aa-tab]', h).forEach(function (t) {
      var on = t.dataset.aaTab === key;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    var name = '';
    all('[data-aa-panel]', h).forEach(function (p) {
      p.hidden = p.dataset.aaPanel !== key;
      if (!p.hidden) name = p.dataset.aaName;
    });
    var n = h.querySelector('[data-aa-use-name]');
    if (n && name) n.textContent = name;
    // one photo per tab, when the set has them
    all('[data-aa-use-img]', h).forEach(function (p) {
      p.hidden = p.dataset.aaUseImg !== key;
    });
  }
  function syncTabs(h) {
    var sel = h.querySelector('[data-aa-tab][aria-selected="true"]');
    if (sel && !shown(sel)) {
      var other = all('[data-aa-tab]', h).filter(function (t) {
        return shown(t) && t.dataset.aaShow;
      })[0];
      if (other) selectTab(h, other.dataset.aaTab);
    }
  }

  /* ---------- material picker: button + listbox ---------- */
  function ddOptions(d) {
    return all('[role=option]', d);
  }
  function ddActive(d, o) {
    ddOptions(d).forEach(function (x) {
      x.classList.toggle('is-active', x === o);
    });
    d.querySelector('[role=listbox]').setAttribute('aria-activedescendant', o.id);
  }
  function ddOpen(d) {
    all('[data-aa-dd]').forEach(function (x) {
      if (x !== d) ddClose(x);
    });
    var btn = d.querySelector('.aa-dd-btn');
    var list = d.querySelector('[role=listbox]');
    btn.setAttribute('aria-expanded', 'true');
    list.hidden = false;
    ddActive(d, d.querySelector('[aria-selected=true]') || ddOptions(d)[0]);
    list.focus();
  }
  function ddClose(d, refocus) {
    var btn = d.querySelector('.aa-dd-btn');
    if (btn.getAttribute('aria-expanded') !== 'true') return;
    btn.setAttribute('aria-expanded', 'false');
    d.querySelector('[role=listbox]').hidden = true;
    if (refocus) btn.focus();
  }
  function ddPick(d, value) {
    ddClose(d, true);
    if (value === mat()) return;
    var y = window.scrollY;
    setMat(value);
    window.scrollTo(0, y);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var d = t.closest && t.closest('[data-aa-dd]');
    all('[data-aa-dd]').forEach(function (x) {
      if (x !== d) ddClose(x);
    });
    if (!d) return;
    var opt = t.closest('[role=option]');
    if (opt) return ddPick(d, opt.dataset.value);
    if (t.closest('.aa-dd-btn')) {
      if (d.querySelector('.aa-dd-btn').getAttribute('aria-expanded') === 'true') ddClose(d, true);
      else ddOpen(d);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      all('[data-aa-label][data-aa-zoomed]').forEach(function (z) {
        zoom(z, false);
      });
    }
    var d = e.target.closest && e.target.closest('[data-aa-dd]');
    if (!d) return;
    var open = d.querySelector('.aa-dd-btn').getAttribute('aria-expanded') === 'true';
    if (!open) {
      if (e.target.matches('.aa-dd-btn') && ['ArrowDown', 'ArrowUp'].indexOf(e.key) > -1) {
        e.preventDefault();
        ddOpen(d);
      }
      return;
    }
    var opts = ddOptions(d);
    var cur = opts.indexOf(d.querySelector('[role=option].is-active'));
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var n = cur + (e.key === 'ArrowDown' ? 1 : -1);
      ddActive(d, opts[Math.max(0, Math.min(opts.length - 1, n))]);
    } else if (e.key === 'Home' || e.key === 'End') {
      e.preventDefault();
      ddActive(d, opts[e.key === 'Home' ? 0 : opts.length - 1]);
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (cur > -1) ddPick(d, opts[cur].dataset.value);
    } else if (e.key === 'Escape') {
      e.preventDefault();
      ddClose(d, true);
    } else if (e.key === 'Tab') {
      ddClose(d);
    }
  });

  /* sock page: the buy bar names the picked tier and its price */
  function bundleBar(l) {
    var t = l.querySelector('aa-bundle-picker .aa-bundle__tier > input:checked');
    var price = l.querySelector('[data-aa-sbar-price]');
    if (!t || !price) return;
    var tier = t.closest('.aa-bundle__tier');
    price.textContent = tier.querySelector('.aa-bundle__title').textContent + ', ' + tier.querySelector('[data-now]').textContent;
  }

  /* ---------- events ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    var l = t.closest('[data-aa-label]');
    if (l && t.closest('aa-bundle-picker')) bundleBar(l);
    if (l && t.name && t.name.indexOf('aa-choice') === 0) {
      l.dataset.aaNotifyState = 'false';
      updateBuy(l);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var l = t.closest('[data-aa-label]');

    var opener = t.closest('[data-aa-dialog-open]');
    if (opener) {
      e.preventDefault();
      var d = document.getElementById(opener.dataset.aaDialogOpen);
      if (d) d.showModal();
      return;
    }
    if (t.closest('[data-aa-dialog-close]')) {
      t.closest('dialog').close();
      return;
    }
    if (t.matches('dialog.aa-gm')) {
      t.close();
      return;
    }
    if (l && (t.closest('[data-aa-zoom-open]') || t.closest('[data-aa-slide] img'))) {
      var panned = panFrom && panFrom.moved;
      panFrom = null;
      if (panned) return;
      zoom(l, !l.dataset.aaZoomed, t.closest('[data-aa-zoom-open]') ? null : e);
      return;
    }
    var thumb = t.closest('[data-aa-thumb]');
    if (thumb && l) {
      showSlide(l, +thumb.dataset.aaThumb, true);
      var again = l.querySelector('[data-aa-thumb="' + thumb.dataset.aaThumb + '"]');
      if (again) again.focus();
      return;
    }
    if (t.closest('[data-aa-notify-open]') && l) {
      var own = l.querySelector('[data-aa-notify][data-aa-variant]');
      if (own) {
        own.hidden = false;
        own.querySelector('input[type=email]').focus();
        return;
      }
      l.dataset.aaNotifyState = 'true';
      updateBuy(l);
      var input = l.querySelector('[data-aa-notify] input[type=email]');
      if (input) input.focus();
      return;
    }
    if (t.closest('[data-aa-sbar-btn]') && l) {
      l.querySelector('[data-aa-buy]').scrollIntoView({ block: 'start', behavior: reduce.matches ? 'auto' : 'smooth' });
      return;
    }
    if (t.closest('[data-aa-pick-set]')) {
      var label = document.querySelector('[data-aa-label]');
      var radio = label && label.querySelector('input[type=radio][value="set"]');
      if (radio) {
        radio.checked = true;
        label.dataset.aaNotifyState = 'false';
        updateBuy(label);
        label.querySelector('[data-aa-buy]').scrollIntoView({ block: 'center', behavior: reduce.matches ? 'auto' : 'smooth' });
        radio.focus({ preventScroll: true });
      }
      return;
    }
    var tab = t.closest('[data-aa-tab]');
    if (tab) {
      selectTab(tab.closest('[data-aa-howto]'), tab.dataset.aaTab);
      return;
    }
    var pin = t.closest('[data-aa-routine] .aa-pin');
    if (pin) {
      var r = pin.closest('[data-aa-routine]');
      r.dataset.aaHeld = pin.dataset.aaPin;
      light(r, +pin.dataset.aaStep, pin.dataset.aaPin);
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-aa-notify]');
    if (!f) return;
    e.preventDefault();
    subscribe(f.closest('[data-aa-label]'), f);
  });

  /* how-to tabs: arrow keys move between tabs */
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-aa-tab]');
    if (!tab || ['ArrowRight', 'ArrowLeft', 'Home', 'End'].indexOf(e.key) < 0) return;
    e.preventDefault();
    var h = tab.closest('[data-aa-howto]');
    var tabs = all('[data-aa-tab]', h).filter(shown);
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    if (e.key === 'Home') i = 0;
    if (e.key === 'End') i = tabs.length - 1;
    var next = tabs[(i + tabs.length) % tabs.length];
    selectTab(h, next.dataset.aaTab);
    next.focus();
  });

  /* routine: a pin and its step light together on hover or focus; a tap keeps it */
  function pointAt(el) {
    var r = el.closest('[data-aa-routine]');
    if (el.classList.contains('aa-pin')) light(r, +el.dataset.aaStep, el.dataset.aaPin);
    else light(r, +el.dataset.aaStep);
  }
  function rest(r) {
    var held = r.dataset.aaHeld;
    if (held) light(r, +held.split('-')[1], held);
    else light(r, +r.dataset.aaHome || 0);
  }
  document.addEventListener('mouseover', function (e) {
    var el = e.target.closest && e.target.closest('[data-aa-routine] [data-aa-step]');
    if (el) pointAt(el);
  });
  document.addEventListener('mouseout', function (e) {
    var el = e.target.closest && e.target.closest('[data-aa-routine] [data-aa-step]');
    if (el && !el.contains(e.relatedTarget)) rest(el.closest('[data-aa-routine]'));
  });
  document.addEventListener('focusin', function (e) {
    var el = e.target.closest && e.target.closest('[data-aa-routine] .aa-pin');
    if (el) pointAt(el);
  });

  /* ---------- start ---------- */
  function init() {
    var fixed = '';
    all('[data-aa-label]').forEach(function (l) {
      if (l.dataset.aaFixed && l.dataset.aaFixed !== 'none') fixed = l.dataset.aaFixed;
    });
    setMat(fixed || mat());

    all('[data-aa-label]').forEach(function (l) {
      bundleBar(l);
      var buy = l.querySelector('[data-aa-buy]');
      var bar = l.querySelector('[data-aa-sbar]');
      if (buy && bar && 'IntersectionObserver' in window) {
        /* the root reaches far below the screen, so the buy box counts as "in view" until it has
           scrolled off the top: the switch happens at the top edge and a fast jump can't skip it */
        new IntersectionObserver(
          function (en) {
            bar.classList.toggle('is-on', !en[0].isIntersecting);
          },
          { rootMargin: '0px 0px 100000px 0px' }
        ).observe(buy);
      }
    });
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        all('[data-aa-routine]').forEach(fitPhoto);
      }, 100);
    });
    // crossing the phone/desktop line re-lays the gallery (the row and the thumbnails' place)
    var flip = function () {
      all('[data-aa-label]').forEach(function (l) {
        showSlide(l, currentSlide(l));
      });
    };
    if (phone.addEventListener) phone.addEventListener('change', flip);
    else if (phone.addListener) phone.addListener(flip);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
